import * as yup from 'yup'
import { MakeRequiredAndNullable } from './utils.js'

export enum SnackwiseInvoiceKeys {
  itemID = 'itemID',
  item = 'item',
  quantity = 'quantity',
  unitPrice = 'unitPrice',
  itemTotal = 'itemTotal',
}

const snackwiseAddressSchema = yup.object().shape({
  contactName: yup.string().nullable().optional(),
  companyName: yup.string().nullable().optional(),
  addressLine1: yup.string().nullable().optional(),
  addressLine2: yup.string().nullable().optional(),
  cityStateZip: yup.string().nullable().optional(),
  country: yup.string().nullable().optional(),
})

export const snackwiseInvoiceFileDataSchema = yup.object().shape({
  organizationLogoOverride: yup.string().nullable().optional(),
  organization: yup
    .object()
    .shape({
      companyName: yup.string().nullable().optional(),
      addressLine1: yup.string().nullable().optional(),
      addressLine2: yup.string().nullable().optional(),
      cityStateZip: yup.string().nullable().optional(),
      country: yup.string().nullable().optional(),
    })
    .required(),
  billTo: snackwiseAddressSchema.required(),
  shipTo: snackwiseAddressSchema.required(),
  invoiceNumber: yup.string().nullable().optional(),
  invoiceDate: yup.string().nullable().optional(),
  coverageStartDate: yup.string().nullable().optional(),
  coverageEndDate: yup.string().nullable().optional(),
  terms: yup.string().nullable().optional(),
  dueDate: yup.string().nullable().optional(),
  poNumber: yup.string().nullable().optional(),
  items: yup
    .array()
    .of(
      yup.object().shape({
        itemID: yup.string().nullable().optional(),
        item: yup.string().nullable().optional(),
        quantity: yup.string().nullable().optional(),
        unitPrice: yup.string().nullable().optional(),
        itemTotal: yup.string().nullable().optional(),
      }),
    )
    .required(),
  salesTax: yup.string().nullable().optional(),
  miscFeesLines: yup
    .array()
    .of(
      yup.object().shape({
        description: yup.string().nullable().optional(),
        amount: yup.string().nullable().optional(),
      }),
    )
    .nullable(),
})

export type SnackwiseInvoiceFileData = yup.InferType<typeof snackwiseInvoiceFileDataSchema>
type RequiredFileData = MakeRequiredAndNullable<SnackwiseInvoiceFileData>

export const snackwiseInvoiceFileMappings: RequiredFileData = {
  organizationLogoOverride: '6e7c5e76-1b22-4563-bc62-6b355f5a137e',
  organization: {
    companyName: '44e0f4f9-ffdc-4340-b7cb-80e31e63217f',
    addressLine1: '57a1c865-bf1d-45ae-b4b2-f8fc2bba4cb5',
    addressLine2: '04ea9c8a-c5ae-4627-8cc1-244c7d5eabf3',
    cityStateZip: '6618c93e-30f3-42ab-bb44-27c68f05572a',
    country: '3067d507-0ae1-4ff0-88a1-bdbe17d7d342',
  },
  billTo: {
    contactName: 'd7f6e6c6-2a93-46c8-82c4-ab0c35fa86e1',
    companyName: 'fc2f93f0-644f-4f4e-8f38-f43ef3d416d6',
    addressLine1: '92c2ed58-f3c3-4db2-85b2-e894066f49c7',
    addressLine2: 'a7cd90d9-f3cb-465f-b438-5f4d3cf55c84',
    cityStateZip: '843d3890-05ec-4b84-bcc4-c8b8375e0619',
    country: 'c91d5c42-1991-4345-9f14-e482bc0557c4',
  },
  shipTo: {
    contactName: 'be1a04a2-61a1-402b-9e91-2a8991d2ef83',
    companyName: 'a4cb813e-1d25-4d2f-91b2-29d7b2fa08a6',
    addressLine1: '0cbe4e67-f39a-4015-85a4-c3f23c635c45',
    addressLine2: '57cd7269-d353-4b33-b6de-59b91f6de87e',
    cityStateZip: 'ca7d46c4-1e83-49c8-8427-9e01a30b5601',
    country: 'd6cb8dc7-4ccf-45a1-8e23-25593cda47e6',
  },
  invoiceNumber: 'c1fe2f1a-3e9d-41c1-9e2d-87f11ea8c11e',
  invoiceDate: '97c1ab18-0932-4d2e-a2ec-775403f72823',
  coverageStartDate: 'c6aa2fd1-0bc4-4a12-8f6b-24a055b1b5d2',
  coverageEndDate: '39c97dcf-ccdb-4683-9f9e-1f4a4cd7d8c6',
  terms: 'c2371654-b1f0-4873-8132-0c51149b75de',
  dueDate: '730c7f25-64b3-41f3-819e-0f2f4e5cf5fc',
  poNumber: 'be53a4a5-56b3-4203-9cc0-bc8f74b3e5ef',
  items: [
    {
      itemID: 'ec5ec130-5f29-43dc-8efe-f9dddc81a97e',
      item: '2ae10cf1-3f6b-43e0-8cf9-d86be179e9f4',
      quantity: '7eb2e63b-3fdf-41f3-a2b3-f75414483f59',
      unitPrice: 'f4a5b1c0-ff6e-4ef5-9ed2-70217a7e8e3d',
      itemTotal: 'd7c0fd47-2c9a-460c-9d4f-6c01277f2fd2',
    },
  ],
  salesTax: 'bd7e5cc9-58dc-44de-bd12-d5b63f4b4a64',
  miscFeesLines: [
    {
      description: 'fae63c4d-c5ad-43b5-b89b-2b598a010b68',
      amount: 'e3c9b308-5981-4422-a118-12b0a18a9dbe',
    },
  ],
}
